import { render, staticRenderFns } from "./DBDownload.vue?vue&type=template&id=43e9bad0"
import script from "./DBDownload.vue?vue&type=script&lang=js"
export * from "./DBDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports